module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "block bg-[#EDF2F7] relative",
    class: _vm.gotFluide ? '' : 'opacity-95',
    attrs: {
      "to": {
        name: 'installation',
        params: {
          id: _vm.$route.params.id,
          idInst: _vm.installation.id
        }
      }
    }
  }, [_c('div', {
    staticClass: "px-3 py-3"
  }, [_c('div', {
    staticClass: "flex items-start justify-between gap-3"
  }, [_c('div', [_c('p', {
    staticClass: "text-lg leading-tight text-bleu-moyen"
  }, [_c('strong', {
    staticClass: "font-bold"
  }, [_vm._v(_vm._s(_vm.installation.nom))])]), _vm._v(" "), (_vm.installation.marque && _vm.installation.modele) ? _c('p', {
    staticClass: "text-sm text-gris mt-0.5"
  }, [_c('span', {
    staticClass: "marque-modele"
  }, [_vm._v("\n                        " + _vm._s(_vm.installation.marque) + " - "), _c('b', [_vm._v(_vm._s(_vm.installation.modele))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "icon-barre",
    staticClass: "shrink-0"
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 flex flex-wrap items-center gap-2"
  }, [(_vm.gotFluide) ? _c('div', {
    staticClass: "flex items-center gap-1 px-3 py-2 rounded-r-full bg-secondary text-white text-sm font-medium -ml-4 pl-5"
  }, [_c('i', {
    staticClass: "inline-block h-5 w-5 mask mask-snow bg-white"
  }), _vm._v("\n                " + _vm._s(_vm.installation.fluide.nom) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.gotFluide) ? _c('div', {
    staticClass: "flex items-center gap-1 rounded-full bg-bleu-moyen text-white text-sm font-medium px-3 py-2"
  }, [_c('i', {
    staticClass: "inline-block h-5 w-5 mask mask-weight bg-white"
  }), _vm._v("\n                " + _vm._s(_vm._f("number")(_vm.installation.charge, '0,00')) + " KG\n            ")]) : _vm._e(), _vm._v(" "), (_vm.installation.i_tag !== null) ? _c('div', {
    staticClass: "flex items-center gap-1 rounded-full bg-otag-install text-white text-sm font-medium px-3 py-2"
  }, [_c('i', {
    staticClass: "inline-block h-5 w-5 mask mask-otag-install bg-white"
  }), _vm._v("\n                " + _vm._s(_vm.installation.i_tag) + "\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "h-4 bg-white"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae83ad9e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/installation/InstallationItem.vue
// module id = 1048
// module chunks = 0